import React, { useCallback, useMemo } from 'react';
import Dropdown from '../Dropdown/Dropdown';
import '../Dropdown/Dropdown.css';

const DEFAULT_PLACEHOLDER = 'Choose saved playlist…';

/**
 * Action dropdown: always shows placeholder; calls onPick(playlistId) when user selects a row.
 */
export default function SavedPlaylistPickerDropdown({
  playlists = [],
  onPick,
  placeholder = DEFAULT_PLACEHOLDER,
  emptyHint = 'No playlists available',
  className = '',
}) {
  const options = useMemo(
    () =>
      (playlists || []).map((p) => ({
        value: p.id,
        label: `${p.name} (${p.tracks?.length || 0} tracks)`,
      })),
    [playlists]
  );

  const getSelectedLabel = useCallback(() => {
    if (!options.length) return emptyHint;
    return placeholder;
  }, [options.length, emptyHint, placeholder]);

  const handleSelect = useCallback(
    (opt) => {
      if (opt?.value) onPick?.(opt.value);
    },
    [onPick]
  );

  return (
    <div
      className={[
        'audio-saved-playlist-dropdown',
        options.length === 0 ? 'audio-saved-playlist-dropdown--empty' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={placeholder}
    >
      <Dropdown
        options={options}
        selectedOption=""
        onSelect={handleSelect}
        getSelectedLabel={getSelectedLabel}
        searchable={options.length > 6}
        searchPlaceholder="Search playlists…"
        menuPortal
        menuPortalMinWidth={280}
        menuPortalClassName="reusable-dropdown-menu--audio-saved-playlist"
      />
    </div>
  );
}
